import { createSlice } from "@reduxjs/toolkit";

const cartSlice2 = createSlice({
  name: "cart2",
  initialState: {
    items: [],
  },
  reducers: {
    addToCart2: (state, action) => {
      const item = action.payload;
      const existingItem = state.items.find((i) => i.id === item.id);
      if (!existingItem) {
        state.items.push({ ...item, quantity: 1 });
      }
    },

    updateQuantity: (state, action) => {
      const { itemId, change } = action.payload;
      const item = state.items.find((i) => i.id === itemId);
      if (item) {
        item.quantity += change;
        if (item.quantity < 1) {
          item.quantity = 1;
        }
      }
    },

    removeFromCart: (state, action) => {
      const itemId = action.payload;
      state.items = state.items.filter((item) => item.id !== itemId);
    },
  },
});

export const { addToCart2, updateQuantity, removeFromCart } =
  cartSlice2.actions;
export default cartSlice2.reducer;
